import { render, staticRenderFns } from "./ProductListingDetails.vue?vue&type=template&id=7245ffce&scoped=true"
import script from "./ProductListingDetails.vue?vue&type=script&lang=js"
export * from "./ProductListingDetails.vue?vue&type=script&lang=js"
import style0 from "./ProductListingDetails.vue?vue&type=style&index=0&id=7245ffce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7245ffce",
  null
  
)

export default component.exports